import axios from 'axios'
import store from '@/vuex'
import router from '@/router'
import {Toast} from 'vant'

function checkPermission(data){
    if(data.result.success==444){
       //Toast(data.result.info)
       store.commit("HIDE_LOADING")
       router.push("/login")
       return false;
    }
}

const config={
    baseURL: process.env.VUE_APP_API,
    timeout: 60000
  }

async function post(url,data){
    config['url']=url
    config['headers']={'htkstoken':store.state.user.token,'Content-Type':'application/json'}
    config['method']='post'

    store.commit("SHOW_LOADING")
    const result=await axios.post(url,JSON.stringify(data),config)
    store.commit("HIDE_LOADING")

    checkPermission(result.data)
    return result.data
}


export {post} 